/* global angular */
( function () {
	'use strict';

	/* eslint-disable max-params */
	function StartObsModal ( logger, $location, $modalInstance, eventModel, scheduleservice, createschedservice, editschedservice, SCHEDULE_MESSAGES ) {
		/* eslint-enable max-params */
		var self = this;

		self.title        = 'Schedule Start Obs';
		self.fetching     = true;
		self.inviteeTitle = SCHEDULE_MESSAGES.invitee;
		self.redirecting  = false;

		function closeModal () {
			$modalInstance.close();
		}

		function saveObsHandler () {
			self.redirecting = true;

			scheduleservice.saveObservation( eventModel )
				.then( function ( res ) {
					scheduleservice.deleteSchedule( eventModel )
						.then( function () {
							logger.notifySuccess( 'Successfully saved.', 'Observation' );
							$location.url( '/observations/' + res.id + '/edit'  );
						} )
						.finally( function () {
							closeModal();
						} );
				}, function () {
					closeModal();
					logger.notifyError( 'An error occurred. Please try again.', 'Observation' );
				} );
		}

		function getTemplateHandler ( template ) {
			logger.info( 'Schools successfully fetched.' );

			// payload needed for observation
			if ( template.name ) {
				eventModel.template = template;
			} else {
				self.noTemplateRights = true;
			}

			self.fetching = false;
		}

		function getInviteesInfo ( observee ) {
			if ( observee ) {
				var invitee = {
					'id'   : observee.PersonnelId,
					'name' : observee.FirstName + ' ' + observee.LastName
				};

				self.eventModel.inviteesInfo.push( invitee );
			}
		}

		function getInviteeHandler ( observee ) {
			if ( eventModel.meta.templateId ) {
				if ( observee ) {
					// payload needed for observation
					eventModel.observeeClientId  = observee.ClientId;
					eventModel.observeeFirstName = observee.FirstName;
					eventModel.observeeLastName  = observee.LastName;
					eventModel.standardizedDate  = scheduleservice.getStandardizeDate( eventModel );
				}

				createschedservice.getTemplate( eventModel.meta.templateId )
					.then( getTemplateHandler, function () {
						$modalInstance.dismiss();
					} );
			} else {
				getInviteesInfo( observee );
				self.fetching = false;
			}
		}

		function maskObservee ( userId ) {
			createschedservice.getUsers( userId )
				.then( function ( resources ) {
					getInviteeHandler( resources );
				} );
		}

		function startObsHandler () {
			var invitees = eventModel.meta.observee || eventModel.meta.invitees;

			invitees.forEach( maskObservee );
		}

		function activate () {
			logger.info( 'Activated Start Observation Schedule Modal View' );

			startObsHandler();

			self.eventModel              = eventModel;
			self.eventModel.inviteesInfo = [ ];
		}

		activate();

		// handlers
		self.saveObsHandler  = saveObsHandler;
		self.startObsHandler = startObsHandler;
		self.closeModal      = closeModal;

		self.internalUtils = {
			'getSchoolsHandler' : getInviteeHandler,
			'getInviteesInfo'   : getInviteesInfo
		};
	}

	angular
		.module( 'app.schedules' )
		.controller( 'StartObsModal', StartObsModal );

	StartObsModal.$inject = [ 'logger', '$location', '$modalInstance', 'eventModel', 'scheduleservice', 'createschedservice', 'editschedservice', 'SCHEDULE_MESSAGES' ];
} )( );
